import $ from 'jquery'

let trigger = trigger || {};
trigger = {
	footer: $('[data-trigger-footer]')
};

let target = target || {};
target = {
	body: $('[data-target-body]'),
	header: $('[data-target-header]'),
	toTop: $('[data-target-totop]'),
	footer: $('[data-target-footer]'),
	cta: $('[data-target-cta]'),
	window: $(window)
};

export function toTop() {
	if (!target.toTop.length) return;
	$(document).on('scroll', () => {
		let height = $('body').innerHeight();
		let footerheight = $('.p-flets-hikari__footer').height();
		let footerBanner = $('p-flets-hikari__nav--footer').height();
		let scrrollBanner = height - (footerBanner * 2) - (footerheight * 2);
		let scrollDistance = $(document).scrollTop();
		if (scrollDistance > 750) {
			target.toTop.addClass('is-show');
			if (scrollDistance > 7000) {
				target.toTop.removeClass('is-show');
			}
		} else {
			target.toTop.removeClass('is-show');
		}
	});
}

export function footerShow() {
	if(!target.footer.length) return;
	let footerHeight = target.footer.height();
	target.body.css('padding-bottom', footerHeight);

	$(document).on('scroll resize', () => {
		let scrollDistance = $(document).scrollTop();
		let windowHeight = target.window.height();
		let footerShowPosition = trigger.footer.offset().top - windowHeight;
		let footerHeight = target.footer.height();

		if(scrollDistance >= footerShowPosition) {
			target.footer.addClass('is-show');
			target.body.css('padding-bottom', footerHeight);
		} else {
			target.footer.removeClass('is-show');
			target.body.css('padding-bottom', 0);
		}
	});
}


// WEBPACK FOOTER //
// ./src/js/util/scrollEvent.js